import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from 'react';
import { Button } from '../../atoms/Button/Button.js';
import { cn } from '../../lib/cn.js';
/**
 * A row of filters over a list, and the one way to clear them.
 *
 * The dashboard and the practice list each had their own copy: the same
 * `flex flex-wrap items-end gap-4` row, the same `min-w-44` cell around every
 * control, and the same clear action written as a bare `<button>` with
 * `h-control-md text-body-sm font-semibold text-primary underline
 * underline-offset-2` — a link's paint on a button's box, with no hover and no
 * focus ring, in both files.
 *
 * The clear action is a `Button` now rather than that string. It is an action
 * in a row of controls, not a navigation, so it is the component the design
 * system already has for exactly that; `ghost` is the variant for an action
 * that sits beside a form rather than committing it. It also settles the
 * alignment the hand-written version was approximating by hand: `md` is
 * `h-control-md`, which is the height the `Select` beside it already is, so
 * `items-end` lines the two up because they are the same size rather than
 * because a literal height was copied onto a `<button>`.
 */
export function FilterBar({ children, onClear, clearLabel, lead, density = 'comfortable', className, }) {
    const compact = density === 'compact';
    return (_jsxs("div", { className: cn('flex flex-wrap items-end', compact ? 'gap-3' : 'gap-4', className), children: [lead ? _jsx("div", { className: "w-full min-w-0 sm:min-w-64 sm:flex-1", children: lead }) : null, Children.map(children, (child) => child ? (_jsx("div", { className: cn('w-full min-w-0', compact ? 'sm:w-44' : 'sm:w-64'), children: child })) : null), onClear ? (_jsx(Button, { variant: "ghost", onClick: onClear, children: clearLabel })) : null] }));
}
//# sourceMappingURL=FilterBar.js.map